import {getCSRF_Token} from "@/fonction/logConnection";
// import contratMock from "@/mock/getContratEntreAdherentEtFournisseur.json";
import {Contrat, ContratCreate, ContratUpdate} from "@/ts/contrat";

import {
  callApi,
  // getDataMock
} from "./_callApi";

export async function getContrats(
  API: string | undefined,
  campagne_id: number,
  contremarque: string | null
): Promise<{
  contrats: Contrat[];
}> {
  try {
    // Introduit un délai artificiel de 1 seconde pour tester le loading
    await new Promise(resolve => setTimeout(resolve, 1000));
    if (
      false
      // getDataMock()
    ) {
      // return contratMock as {contrats: Contrat[]};
    } else {
      if (!API) {
        throw new Error("API is not provided.");
      }

      const reponse = await callApi(
        `${API}/api/coact/v1/contrats?campagne_id=${campagne_id}`,
        "GET",
        {
          "Content-Type": "application/json",
          "X-CSRF-Token": getCSRF_Token(),
          "X-Coact-Contremarque": contremarque,
        },
        "include"
      );
      return reponse as {contrats: Contrat[]};
    }
  } catch (error: any) {
    throw new Error(error?.message);
  }
}

export async function getContrat(
  API: string | undefined,
  contrat_id: number,
  contremarque?: string
): Promise<Contrat> {
  try {
    // Introduit un délai artificiel de 1 seconde pour tester le loading
    await new Promise(resolve => setTimeout(resolve, 1000));
    if (
      false
      // getDataMock()
    ) {
      // return contratMock as {contrats: Contrat[]};
    } else {
      if (!API) {
        throw new Error("API is not provided.");
      }

      const reponse = await callApi(
        `${API}/api/coact/v1/contrats/${contrat_id}`,
        "GET",
        {
          "Content-Type": "application/json",
          "X-CSRF-Token": getCSRF_Token(),
          ...(contremarque ? {"X-Coact-Contremarque": contremarque} : {}),
        },
        "include"
      );
      return reponse as Contrat;
    }
  } catch (error: any) {
    throw new Error(error?.message);
  }
}

export async function createContrat(
  API: string | undefined,
  body: ContratCreate,
  currentContremarque: string | null
): Promise<Contrat> {
  try {
    const reponse = await callApi(
      `${API}/api/coact/v1/contrats`,
      "POST",
      {
        "Content-Type": "application/json",
        "X-CSRF-Token": getCSRF_Token(),
        "X-Coact-Contremarque": currentContremarque,
      },
      "include",
      body
    );
    return reponse as Contrat;
  } catch (error: any) {
    throw new Error(error?.message);
  }
}

export async function updateContrat(
  API: string | undefined,
  body: ContratUpdate,
  contratId: number,
  currentContremarque: string | null
): Promise<Contrat> {
  try {
    const reponse = await callApi(
      `${API}/api/coact/v1/contrats/${contratId}`,
      "PATCH",
      {
        "Content-Type": "application/json",
        "X-CSRF-Token": getCSRF_Token(),
        "X-Coact-Contremarque": currentContremarque,
      },
      "include",
      body
    );
    return reponse as Contrat;
  } catch (error: any) {
    throw new Error(error?.message);
  }
}

export async function cloturerContrat(
  API: string | undefined,
  contratId: number
): Promise<void> {
  try {
    const reponse = await callApi(
      `${API}/api/coact/v1/contrats/${contratId}/cloturer`,
      "PATCH",
      {
        "Content-Type": "application/json",
        "X-CSRF-Token": getCSRF_Token(),
      },
      "include"
    );
    console.log(reponse);
  } catch (error: any) {
    throw new Error(error?.message);
  }
}

export async function reouvrirContrat(
  API: string | undefined,
  contratId: number
): Promise<void> {
  try {
    const reponse = await callApi(
      `${API}/api/coact/v1/contrats/${contratId}/activer`,
      "PATCH",
      {
        "Content-Type": "application/json",
        "X-CSRF-Token": getCSRF_Token(),
      },
      "include"
    );
    console.log(reponse);
  } catch (error: any) {
    throw new Error(error?.message);
  }
}
